import { H3 } from "@/components/ui/typography";
import DashboardTableau from "./tableau/DashboardTableau";

export default function TabDashboardTableau() {
  return (
    <div className="flex flex-col gap-y-8">
      <H3>Dashboard Linknet - Tableau</H3>
      <DashboardTableau />
    </div>
  );
}
